
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionsListComponent } from './components/connections-list/connections-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchConnectionPipe } from './search-connection.pipe';
import { ConnectionConfirmDeleteComponent } from './components/connection-confirm-delete/connection-confirm-delete.component';
import { StatusPipe } from './status.pipe';
import { InfraPipe } from './infra.pipe';
import { TenantPipe } from './tenant.pipe';
import { ConnectionConfirmRecreateComponent } from './components/connection-confirm-recreate/connection-confirm-recreate.component';
import { WhatsappOptionsComponent } from './components/whatsapp-options/whatsapp-options.component';
import { IntegrationTestComponent } from './components/integration-test/integration-test.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { GlobalSettingsComponent } from './components/global-settings/global-settings.component';
import { ConnectionSettingsComponent } from './components/connection-settings/connection-settings.component';
import { ConnectionScreenshotComponent } from './components/connection-screenshot/connection-screenshot.component';
import { ConnectionConfirmRestartComponent } from './components/connection-confirm-restart/connection-confirm-restart.component';

@NgModule({
  declarations: [
    ConnectionsListComponent,
    SearchConnectionPipe,
    ConnectionConfirmDeleteComponent,
    StatusPipe,
    InfraPipe,
    TenantPipe,
    ConnectionConfirmRecreateComponent,
    WhatsappOptionsComponent,
    IntegrationTestComponent,
    GlobalSettingsComponent,
    ConnectionSettingsComponent,
    ConnectionScreenshotComponent,
    ConnectionConfirmRestartComponent
  ],
  imports: [
    QRCodeComponent,
    MatListModule,
    MatTooltipModule,
    MatIconModule,
    NgSelectModule,    
    MatSelectModule,
    MatDialogModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    MatExpansionModule
  ]
})
export class NiboWhatsappModule { }
